/**
 * Classic H: a magic wall under a mass of boulders (docs/spec/03 §2). Dig the seam just above the
 * wall and the mass comes down through it as a rain of diamonds into the chamber below.
 * The two shafts beside the chamber are the only way down to its doors and to the exit, so they are
 * plain dirt: random boulders there could seal both (level 1 once did).
 */

import type { CaveDef } from '../types';

export const caveH: CaveDef = {
  id: 'H',
  name: 'ALCHEMY',
  hint: 'The wall under the rocks is not what it seems.',
  intermission: false,
  colors: [4, 3, 1],
  diamondValue: 20,
  extraValue: 30,
  magicWallTime: 12,
  fill: { base: '.', items: [['r', 10], ['d', 3]] },
  levels: [
    { seed: 1901, diamonds: 20, time: 130 },
    { seed: 1902, diamonds: 24, time: 120 },
    { seed: 1903, diamonds: 28, time: 110 },
    { seed: 1904, diamonds: 32, time: 100 },
    { seed: 1905, diamonds: 36, time: 90 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W...???????????????????????????????????W',
    'W.P.???????????????????????????????????W',
    'W...???????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W???rr?rr.r?rrr?r.rr?rr.r?rrr?r.rr?r???W',
    'W???r?rr?rr.rr?rr?rr.rr?rr.rr?rr?rrr???W',
    'W???rrr.rr?rrr.rrr?rrr.rr?rrr.rr?rrr???W',
    'W?....................................?W',
    'W..WmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmW..W',
    'W..W                                W..W',
    'W..W                                W..W',
    'W..W                                W..W',
    'W..W                                W..W',
    'W...                                ...W',
    'W..WwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwW..W',
    'W??????????????????????????????????????W',
    'W??????????????????????????????????????W',
    'W???????????????????????????????????X??W',
    'W??????????????????????????????????????W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
